const fieldDic = {
    serial_no: {
        fields: [{
            field: 'serial_no',
            name: 'Serial No',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 12 &&
                    val.length <= 14 ? [] : ['Serial No must be between 12 - 14 characters long']
            }
        }, ],
    },
    simcard_no: {
        fields: [{
            field: 'simcard_no',
            name: 'Simcard No',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 13 &&
                    val.length <= 20 ? [] : ['Serial No must be between 13 - 20 characters long']
            }
        }, ],
    },
    act_date: {
        fields: [{
            field: 'act_date',
            name: 'Activation Date (YYYY-MM-DD)',
            validate: function(val) {
                return typeof val == 'string' &&
                    isValidDate(val) ? [] : ['Activation Date must be YYYY-MM-DD format'];
            }
        }, ],
    },
    return_date: {
        fields: [{
            field: 'return_date',
            name: 'Return Date (YYYY-MM-DD)',
            validate: function(val, simcard) {
                let errorMessages = typeof val == 'string' &&
                    isValidDate(val) ? [] : ['Return Date must be YYYY-MM-DD format'];
                if (errorMessages.length > 0) return errorMessages;
                try {
                    if (new Date(val) <= new Date(simcard['Activation Date (YYYY-MM-DD)'])) {
                        errorMessages.push('Return Date must be later than Activation Date')
                    }
                } catch (e) {
                    //be silent
                }
                return errorMessages;
            }
        }, ],
    },
    name: {
        fields: [{
            field: 'name',
            name: 'Name',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 2 ? [] : ['Name is at least 2 character'];
            }
        }, ],
    },
    email: {
        fields: [{
            field: 'email',
            name: 'Email',
            validate: function(val) {
                return typeof val == 'string' &&
                    isValidEmail(val) ? [] : ['Email must be valid email format'];
            }
        }, ],
    },
    tel: {
        fields: [{
            field: 'tel',
            name: 'Contact Phone Number',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 9 ? [] : ['Contact Phone Number is at least 9 character'];
            }
        }, ],
    },
    state: {
        fields: [{
                field: 'state',
                name: 'Arrival State or Province',
                validate: function(val) {
                    return typeof val == 'string' &&
                        val.length >= 2 ? [] : ['Arrival State or Province is at least 2 character'];
                }
            },
            {
                field: 'city',
                name: 'Arrival City',
                validate: function(val) {
                    return typeof val == 'string' &&
                        val.length >= 2 ? [] : ['Arrival City Number is at least 2 character'];
                }
            },
            // {
            //     field: 'zip_code',
            //     name: 'Zip Code or Post Code (Optional)',
            // },
        ],
    },
    passport: {
        fields: [{
            field: 'passport',
            name: 'Passport Number',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 2 ? [] : ['Passport Number must be between 9 - 10 characters long'];
            }
        }, ]
    },
    passport_image: {
        fields: [{
            field: 'passport_image',
            name: 'Passport Image',
            validate: function() {
                return ['Cannot submit act request if any simcard require passport image.'];
            }
        }, ]
    },
    passport_name: {
        fields: [{
            field: 'passport_name',
            name: 'Name on Passport',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 2 ? [] : ['Name on Passport is at least 2 character'];
            }
        }, ]
    },
    dob: {
        fields: [{
            field: 'dob',
            name: 'Birthday (YYYY-MM-DD)',
            validate: function(val) {
                return typeof val == 'string' &&
                    isValidDate(val) ? [] : ['Birthday must be YYYY-MM-DD format'];
            }
        }, ]
    },
    IMEI: {
        fields: [{
            field: 'IMEI',
            name: 'IMEI',
            validate: function(val) {
                return typeof val == 'string' &&
                    isIMEI(val) ? [] : ['IMEI must be valid IMEI format.'];
            }
        }, ]
    },
    card_account: {
        fields: [{
            field: 'card_account',
            name: 'SIM Card Mobile Number',
            validate: function(val) {
                return typeof val == 'string' &&
                    val.length >= 9 && val.length <= 20 ? [] : ['SIM Card Mobile Number must be between 9 - 20 characters long'];
            }
        }, ]
    }
};

function getFields(key) {
    if (!fieldDic[key]) throw new Error(`No Field With Key '${key}'`);
    return fieldDic[key].fields;
}

function getFieldsNameByKey(key) {
    if (!fieldDic[key]) throw new Error(`No Field With Key '${key}'`);
    return fieldDic[key].fields.map(field => field.name);
}

function getMapOfNameToField() {
    return Object.values(fieldDic)
        .map(o => o.fields)
        .flat()
        .reduce((map, field) => {
            map[field.name] = field.field;
            return map;
        }, {});
}

/**
 * ref: https://stackoverflow.com/questions/18758772/how-do-i-validate-a-date-in-this-format-yyyy-mm-dd-using-jquery
 */
function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false; // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === dateString;
}

/**
 * ref: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 */
function isValidEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

/**
 * ref: https://www.dotnetspider.com/resources/29819-Javascript-For-IMEI-Validation.aspx
 */
function isIMEI(s) {
    var etal = /^[0-9]{15}$/;
    if (!etal.test(s)) {
        return false;
    }
    let sum = 0,
        mul = 2,
        l = 14;
    for (let i = 0; i < l; i++) {
        let digit = s.substring(l - i - 1, l - i);
        let tp = parseInt(digit, 10) * mul;
        if (tp >= 10)
            sum += (tp % 10) + 1;
        else
            sum += tp;
        if (mul == 1)
            mul++;
        else
            mul--;
    }
    let chk = ((10 - (sum % 10)) % 10);
    if (chk != parseInt(s.substring(14, 15), 10))
        return false;
    return true;
}

export default {
    NAME_SIMCARD_NO: 'Simcard No',
    getFields,
    getFieldsNameByKey,
    getMapOfNameToField,
}